export default "__VITE_ASSET__D$5MI3Wv__"